/**
 * Free marketing tools (top-level routes, not under /tools/).
 */

export interface FreeToolEntry {
  slug: string;
  path: string;
  label: string;
  shortDescription: string;
}

export const freeTools: FreeToolEntry[] = [
  {
    slug: 'canva-palette',
    path: '/canva-palette/',
    label: 'Canva Palette Extractor',
    shortDescription: 'Colors, fonts, and images from a Canva share link',
  },
  {
    slug: 'og-card-preview',
    path: '/og-card-preview/',
    label: 'OG Image Size Checker',
    shortDescription: 'Check live og:image against 1200×630',
  },
  {
    slug: 'og-image-sizes',
    path: '/og-image-sizes/',
    label: 'OG Image Size Guide',
    shortDescription: 'Platform sizes for Facebook, X, LinkedIn, Slack',
  },
  {
    slug: 'bulk-create-csv-checker',
    path: '/bulk-create-csv-checker/',
    label: 'Bulk Create CSV Checker',
    shortDescription: 'Row cap, image URLs, and empty cells before upload',
  },
];
